module.exports = __webpack_public_path__ + "img/text-mark1.e7fe968b.png";